<template>
  <div class="main text-left">
    <div class="form-floating mb-3">
      <input type="email" class="form-control" id="floatingUsername" v-model="input.username" :maxlength="50"
        :placeholder="this.$t('lang.dict.email')">
      <label for="floatingUsername">{{ this.$t('lang.dict.email') }}</label>
    </div>
    <div class="form-floating mb-3">
      <input onfocus="this.type='password'" class="form-control" id="floatingPassword" v-model="input.password"
        :maxlength="50" :placeholder="this.$t('lang.dict.password')">
      <label for="floatingPassword">{{ this.$t('lang.dict.password') }}</label>
    </div>
    <button type="submit" class="btn btn-info" v-on:click="register()">{{ this.$t('lang.toolbar.Register')
      }}</button>

    <p><br>
      <span class="fs-6 text-muted">{{ this.$t('lang.msg.toLogin') }}<span class="btn btn-link"
          v-on:click="toLogin()">{{ this.$t('lang.toolbar.Login') }}</span></span>
    </p>
  </div>
</template>
<script>
import { Modal } from 'bootstrap'
import sx from '../../utils/core.js'
import vl from '../../utils/validate.js'

// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  data() {
    return {
      input: {
        name: '',
        username: '',
        password: ''
      }
    }
  },
  mounted() {
    var that = this;
    that.$store.state.confirmdef = {
      title: that.$t('lang.toolbar.Confirm'),
      msg: that.$t('lang.msg.toRegister'),
      event: 'Register'
    }
  },
  methods: {
    toLogin() {
      this.$router.replace({ name: 'Login' })
    },
    register() {
      const that = this
      if (this.input.username != '' && this.input.password != '') {
        if (!vl.isEmail(that.input.username)) {
          sx.toastError(that.$t('lang.error.invalid', { str: this.$t('lang.dict.username') }));
          return;
        }
        const myconfirmModal = new Modal(document.querySelector("#myModalConfirm"));
        myconfirmModal.show();
        $("#confirm").click(function () {
          myconfirmModal.hide();
          if (that.$router.currentRoute.name != "Register") {
            return
          }
          var params = {
            username: that.input.username,
            password: that.input.password,
            token: ''
          }
          const mymodal = sx.showWaiting()
          sx.request(
            that.$store.state.baseurl + '/app/authhelper/register',
            params,
            function (result) {
              if (result.status === 'ok') {
                localStorage.setItem('username', that.input.username)
                localStorage.setItem('password', sx.encrypt(that.input.password, ''))
                sx.toastSuccess(that.$t('lang.info.succeedRegister'))
                that.$router.replace({ name: 'Login' })
              } else {
                sx.toastSuccess(that.$t('lang.info.succeedRegisterDup'))
                that.$router.replace({ name: 'Login' })
              }
            },
            function (result) {
              sx.toastError(that.$t('lang.error.failed', { str: that.$t('lang.toolbar.Register') }));
              console.log('register failed', result)
            }
          )
          sx.hideWaiting(mymodal)
        })
      } else {
        sx.toastError(that.$t('lang.error.required', { str: that.$t('lang.dict.email') + ',' + that.$t('lang.dict.password') }));
        console.log('A username and password must be present')
      }
    }
  }
}
</script>
